import React, { useMemo } from 'react'
import { LegalDocsItemProps } from '../../organisms/Tabs/LegalDocsTabs/types'
import LegalDocsTabsSection from '../../sections/LegalDocsTabsSection'
import LegalDocsSection from '../..//sections/LegalDocsSection'
import usePageContext from '../../../hooks/usePageContext'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import { DocsTabsSliceProps } from './types'

const DocsTabsSlice: React.FC<DocsTabsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { dt_title, dt_subtitle, dt_description, dt_is_heading_green, dt_is_main_heading, dt_hide_tabs } = primary || {}
  const { group } = usePageContext()

  const data: LegalDocsItemProps[] = useMemo(
    () =>
      items.map((item, index) => {
        const { tab_title = '', tab_image, content_text, content_document } = item || {}
        const { documents = [] } = content_document?.document?.data || {}

        return {
          id: `${index}`,
          tabKey: `${index}`,
          tabIcon: tab_image,
          title: tab_title,
          item: {
            list: documents.map((item, index) => ({
              key: `${index}`,
              title: item?.document_title || '',
              url: resolvePrismicLink(item?.document_link, group) || '#'
            })),
            text: content_text?.text
          }
        }
      }),
    [items]
  )

  if (dt_hide_tabs) {
    return (
      <LegalDocsSection
        heading={dt_title?.text}
        subheading={dt_subtitle?.text}
        isHeadingGreen={dt_is_heading_green}
        isMainHeading={dt_is_main_heading}
        headingPadding={['45px', '', '85px']}
        description={dt_description?.html}
        inner="inners.primary"
        paddingTop={['40px', '', '84px']}
        paddingBottom={['40px', '', '80px']}
        data={data[0]?.item?.list}
      />
    )
  }

  return (
    <LegalDocsTabsSection
      heading={dt_title?.text}
      subheading={dt_subtitle?.text}
      isHeadingGreen={dt_is_heading_green}
      isMainHeading={dt_is_main_heading}
      headingPadding={['45px', '', '85px']}
      description={dt_description?.html}
      inner="inners.fullWidth"
      paddingTop={['40px', '', '84px']}
      paddingBottom={['40px', '', '80px']}
      data={data}
    />
  )
}

export default DocsTabsSlice
